import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import useTpvsService from '../../../services/TpvsService';
import { AppContext } from '../../../sporttia/AppContext';
import TPVUrlPurchase from './TPVUrlPurchase';
import TpvTokenizedPaycometPurchase from './TpvTokenizedPaycometPurchase';
import SttFullPageSpinner from '../../../sporttia/spinners/SttFullPageSpinner';

/**
 * Sporttia ofrece diferentes métodos de pago. Este componente renderiza el componente para pagar según el banco del TPV.
 * Anteriormente, se utilizaba TPVSwitcherLegacy con este propósito. Dado que no se han migrado todos los métodos de pago al nuevo componente,
 * TPVSwitcherLegacy se utiliza como fallback.
 */
export default function TPVSwitcher() {
    const tpvService = useTpvsService();
    const cxt = useContext(AppContext)!;
    const { id } = useParams<{ id: string }>();

    const { data: collectedTpv, isLoading } = tpvService.useGetTpv(
        parseInt(id || '0'),
    );

    if (isLoading) {
        return <SttFullPageSpinner />;
    }

    if (!collectedTpv) {
        return null;
    }

    if (
        collectedTpv.tpv.tpvConf.bank !== 'PAYCOMET' ||
        !cxt.user?.paycometIdUser
    ) {
        return <TPVUrlPurchase tpv={collectedTpv.tpv} />;
    }
    return <TpvTokenizedPaycometPurchase tpv={collectedTpv?.tpv} />;
}
